import { onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'

import { $can } from '@/services/roles'

const fallbackRoutes: Array<{ permission: string; path: string }> = [
  { permission: 'manageUsers', path: '/users' },
  { permission: 'viewSpeakers', path: '/speakers' },
  { permission: 'viewEvents', path: '/events' },
  { permission: 'viewFestivalShop', path: '/festival-shop' },
  { permission: 'viewCompany', path: '/partner-company' },
  { permission: 'viewDocuments', path: '/documents' },
  { permission: 'viewProspectCatalog', path: '/prospects' },
  { permission: 'viewLeads', path: '/myleads' },
  { permission: 'viewRecruitingPlus', path: '/recruiting-plus' },
  { permission: 'viewVisitorProfiles', path: '/visitor-profiles' },
]

function canAccess(permission: string): boolean {
  return $can(permission, { for: 'User' })
}

function roleRedirect(pagePermission: string | string[], router: ReturnType<typeof useRouter>) {
  const permissions = Array.isArray(pagePermission) ? pagePermission : [pagePermission]
  if (permissions.some(canAccess)) return

  const fallback = fallbackRoutes.find((route) => canAccess(route.permission))
  // Dashboard is accessible to everyone -- use as final fallback
  return router.push(fallback?.path ?? '/dashboard')
}

export function useRoleRedirect(pagePermission: string | string[]) {
  const router = useRouter()
  onMounted(async () => {
    await nextTick()

    roleRedirect(pagePermission, router)
  })
}
